import type { FaireProductEntity } from "../../entity_types/product";

export const p_9a2uvmc3hg: FaireProductEntity = {
  token: "p_9a2uvmc3hg",
  type: "product",
  name: "OPTIMIZE MINERALS™️",
  brandToken: "b_vjrx63e348",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/193e275c49502ffa9d01cea856830438e67ffba084f02011510679c5e292cbcb.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/75932c5c5bcf40d5be0cdfdf4620721149f0c8b54c5462f79ee04d13698909b6.png",
    "https://cdn.faire.com/fastly/705ed33516b93aac427562be26ee89882a5be4f9c74aacab3dff9a797be70846.png",
    "https://cdn.faire.com/fastly/f8a459abee43c2514f130f41df89ef441e31d4de0b3fef7249d0f07231b92700.png",
    "https://cdn.faire.com/fastly/cd15556e27ea740f5f12a6bbb79dfffdd353edccbeae131869da4daaf58061d8.png",
  ],
  priceDollars: 49,
  description:
    "\nOur flagship product was designed with much thought and research. This product contains all essential minerals needed daily for proper function. You are getting the highest quality of bioavailable minerals, and nutrients all in 1. It would cost over $200 dollars to attempt to replicate the quality in this bag monthly. This 1 powder contains 10+ pills/ supplements to help you condense and simplify your routine. This product was designed to have the flexibility to consume with or without food. It is also fasting friendly. With our powder delivery system, you may absorb a majority of this product in as fast as 30 seconds and may notice a difference within days. Everyone's timeline is different! Due to the science behind minerals, you may notice a wide array of benefits. Potentially including an increase in cellular energy, limit the reliance on caffeine, improve brain function & focus. Over 100k units sold and counting\n",
  tags: [],
  msrpDollars: 98,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:01.590Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
